import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/display.css';
import "./views/less/home-page.less";

Vue.use(ElementUI);
new Vue({
    router,
    store,
    beforeCreate() {
        // 在 Vue 实例创建之前将 db 方法添加到原型上  
        // Vue.prototype.$Url = 'http://t-api.www.fjdxlkj.com';
        Vue.prototype.$Url = window.SITE_CONFIG.baseUrl;
        //http://mgr.www.fjdxlkj.com/api/app-api
    },
    template: '<App/>',

    components: { App }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js